"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.constructTypeMap=constructTypeMap;function constructTypeMap(a){return Object.fromEntries(Object.entries(a).map(a=>{let[b,c]=a;return[c,b]}))}
